<template>
  <div class="overflow-hidden rounded-2xl border border-[#1c4848]/10 bg-white">
    <div class="relative" :class="attrs.image ? 'bg-[#143838]' : ''">
      <img v-if="attrs.image" :src="attrs.image" alt="" class="absolute inset-0 h-full w-full object-cover" draggable="false">
      <div v-if="attrs.image" class="absolute inset-0 bg-black/50"></div>
      <div class="relative px-8 py-8 text-center">
        <span class="block font-display text-6xl leading-8 text-[#c9a961]" aria-hidden="true">“</span>
        <BlockField :model-value="attrs.text" center :on-dark="Boolean(attrs.image)" placeholder="The line readers should remember" :read-only="readOnly" :input-class="`font-display text-2xl font-semibold italic leading-snug ${attrs.image ? 'text-white' : 'text-[#1c4848]'}`" @update:model-value="set({ text: $event })" />
        <BlockField :model-value="attrs.author" center :on-dark="Boolean(attrs.image)" placeholder="Who said it" :read-only="readOnly" :input-class="`text-xs font-semibold ${attrs.image ? 'text-[#ecd79f]' : 'text-[#a0833c]'}`" @update:model-value="set({ author: $event })" />
      </div>
    </div>
    <div v-if="!readOnly" class="flex flex-wrap items-center gap-2 px-3 py-2">
      <ImagePicker :context="context" :has-image="Boolean(attrs.image)" compact @picked="set({ image: $event })" />
      <button v-if="attrs.image" type="button" class="min-h-8 rounded-md px-2 text-[11px] font-bold text-[#1c4848]/60 hover:bg-[#1c4848]/5" @click="set({ image: '' })">Remove picture</button>
    </div>
  </div>
</template>

<script setup>
import BlockField from '@/components/writer/views/BlockField.vue';
import ImagePicker from '@/components/writer/views/ImagePicker.vue';

defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
</script>
